module.exports = __webpack_public_path__ + "static/media/up-bow-svgrepo-com.1af167a8.svg";